import { StaffSiteData } from './staff-site-data';
import { ApplicationUserData } from './application-user-data';
import { StaffRateTypeData } from './staff-rate-type-data';

/* Copyright CADS
 *
 * All rights are reserved. Reproduction or transmission in whole or in part, in
 * any form or by any means, electronic, mechanical or otherwise, is prohibited
 * without the prior written consent of the copyright owner.
 *
 * THIS FILE IS AUTO GENERATED DO NOT EDIT IT MANULLY
 *
 */

export class StaffDetailsWebAppData {
  StaffId: string;
  ContactName: string;
  EmailAddress: string;
  Sites: StaffSiteData[];
  SiteDepotIds: string[];
  RoleId: string;
  PhoneNumber: string;
  UserAccount: ApplicationUserData;
  UserCode: string;
  Claims: string[];
  Roles: string[];
  EulaAgreedVersion: string;
  CanEstimate: boolean;
  QuickId: string;
  RateTypes: StaffRateTypeData[];
  Deleted: boolean;
  LastModified: string;
  CompanyPosition: string;
}


